import { ShareMessageFragment } from "~/__generated__/graphql"
import { HighlightedMessage } from "./highlighted-message"

interface TopMessagesSectionProps {
  messages: ShareMessageFragment[]
}

export const TopMessagesSection = ({ messages }: TopMessagesSectionProps) => {
  return (
    <div className="flex flex-col px-4">
      {messages.map((message) => (
        <div key={message.id} className="gap-3 py-4">
          <HighlightedMessage message={message} showHeader={false} compact={true} />
        </div>
      ))}
    </div>
  )
}
